import { render } from "./BundledAssetsUpload.vue?vue&type=template&id=7ba08c74"
import script from "./BundledAssetsUpload.vue?vue&type=script&lang=js"
export * from "./BundledAssetsUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__